// extracted by mini-css-extract-plugin
export default {"button":"ScrollTopButton_button__-b6FO"};